<h1>Albion Free Market Change Log</h1>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Crafting Calculator Improvements</mat-card-title>
    <mat-card-subtitle>June 8th, 2025</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Added the ability to ignore journals in the crafting calculator.</p>
    <p>Added multiple life of quality improvements in the crafting calculator.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Crafting Calculator Bugfixes</mat-card-title>
    <mat-card-subtitle>June 6th, 2025</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>We've published several important bugfixes to the new Crafting Calculator.</p>
    <p>Thank you to all users who reported these issues.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>New Crafting Calculator Released!</mat-card-title>
    <mat-card-subtitle>June 3rd, 2025</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>We're excited to announce the release of our enhanced Crafting Calculator with powerful new features:</p>
    <ul class="bullet-point-list">
      <li>Advanced Profit Analysis - Calculate detailed profit margins for all crafting recipes</li>
      <li>Resource Return Rate Calculator - Optimize your resource efficiency with precise RRR calculations</li>
      <li>Focus Cost Integration - Automatic focus cost calculations based on your specialization levels</li>
      <li>Journal Integration - Factor in journal usage for accurate fame and profit calculations</li>
      <li>Leftover Materials Tracking - Account for excess materials in your profit calculations</li>
      <li>Real-time Market Data - Live price updates from the Albion Online Data Project</li>
    </ul>
    <p>This comprehensive tool helps crafters make informed decisions and maximize their silver per hour across all crafting disciplines.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Your Flips Charts</mat-card-title>
    <mat-card-subtitle>April 20, 2025</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Added historical charts to the Your Flips page.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Dungeons on Map</mat-card-title>
    <mat-card-subtitle>April 16, 2025</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Added the option to highligh dungeons on the map.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Journal Calculator Fix</mat-card-title>
    <mat-card-subtitle>April 4th, 2025</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Added missing happiness percentages to the Journal Calculator.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Flipper UI/UX, Meta Items and much more</mat-card-title>
    <mat-card-subtitle>March 20, 2025</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>The Flipper UI has been redesigned for better usability and accessibility, especially for new players.</p>
    <p>The changes will also facilitate future updates.</p>
    <p>The Meta Items page now spans 28 days.</p>
    <p>Added missing RRR to the craft calculator.</p>
    <p>Since the last changelog entry, there have been multiple performance and backend improvements, including a new powerful server.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Smuggler's Network Black Market Flipping</mat-card-title>
    <mat-card-subtitle>February 6, 2025</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>The Black Market Flipper is now completely integrated with the Smuggler's Network.</p>
    <p>When you choose the location you're buying from, it'll automatically calculate and consider the transport fees.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Map Improvements</mat-card-title>
    <mat-card-subtitle>February 3rd, 2025</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Multiple improvements to the map and pathfinding.</p>
    <p>Now you can see a summary of the path, including the expected travel time considering the speed you set.</p>
    <p>Path is automatically updated once you change any of the settings.</p>
    <p>Show start and finish indicators on the map.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Albion Map and Pathfinding</mat-card-title>
    <mat-card-subtitle>February 2nd, 2025</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Added a new interactive map feature with pathfinding capabilities.</p>
    <p>Other minor UI/UX improvements.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Your Flips Improvements, New Tutorials</mat-card-title>
    <mat-card-subtitle>January 12, 2025</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>The "Your Flips" page now shows the current prices for failed flips. This will help you decide if you should sell them or wait for a better price.</p>
    <p>New tutorials released.</p>
    <p>Multiple other minor improvements.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Multiple Improvements</mat-card-title>
    <mat-card-subtitle>December 12, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>In the last month, there have been multiple improvements to the AFM website. Due to time constraints and prioritization, I wasn't able to post all the updates here. So here's a summary:</p>
    <p>Farming Calculator:</p>
    <ul class="bullet-point-list">
      <li>Added a new tool to calculate farming profits!</li>
    </ul>
    <p>Flipper:</p>
    <ul class="bullet-point-list">
      <li>CSV exports are now automatically localized, so you can open them directly (usage of localized separators).</li>
    </ul>
    <p>Prices Favorites:</p>
    <ul class="bullet-point-list">
      <li>Prices Favorites now have a new button to export prices to CSV.</li>
    </ul>
    <p>Framework Improvements:</p>
    <ul class="bullet-point-list">
      <li>Multiple improvements to the framework, making the website faster to load.</li>
    </ul>
    <p>There are multiple other UI and functionality improvements that I won't list here.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Show flips last hour usage</mat-card-title>
    <mat-card-subtitle>November 2nd, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Flipper:</p>
    <ul class="bullet-point-list">
      <li>Show per city last hour consumed flips.</li>
      <li>This allows the user to better choose where to flip from.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Mark Flips as Failed</mat-card-title>
    <mat-card-subtitle>September 22, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Your flips:</p>
    <ul class="bullet-point-list">
      <li>You can now mark flips as failed.</li>
      <li>In the future, this will be used to help you sell those items.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Journal Calculator, Albion Online Data Project Identifiers</mat-card-title>
    <mat-card-subtitle>August 20, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Journal Calculator:</p>
    <ul class="bullet-point-list">
      <li>New tool released. For all the island laborers out there, you can use this to better calculate your expected profit.</li>
    </ul>
    <p>Data Client Identifiers:</p>
    <ul class="bullet-point-list">
      <li>New tool released. Simply copy and paste the data upload identifier from AODP's data client to know it's path in their servers.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Flipper Improvements</mat-card-title>
    <mat-card-subtitle>July 31, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Flipper:</p>
    <ul class="bullet-point-list">
      <li>New filters: tiers, upgrades and max rune count.</li>
      <li>Better sorting of Upgrade Items.</li>
      <li>Small UI improvements.</li>
    </ul>
    <p>Your flips:</p>
    <ul class="bullet-point-list">
      <li>Text Filter.</li>
      <li>More detailed stats.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>User Flips</mat-card-title>
    <mat-card-subtitle>July 23rd, 2024 (2nd post)</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>User flips:</p>
    <ul class="bullet-point-list">
      <li>Users can now see their flips history.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>CSV Exporter For Flipper</mat-card-title>
    <mat-card-subtitle>July 23rd, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Flipper CSV exporter:</p>
    <ul class="bullet-point-list">
      <li>Users can now export CSV files for all flips or for their consumed flips only.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Flipper Improvements</mat-card-title>
    <mat-card-subtitle>July 14th, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Improved Flipper UI/UX:</p>
    <ul class="bullet-point-list">
      <li>Flipper now can load upgrade prices from sell orders, buy orders or averages.</li>
      <li>Setup fee is applyed automatically.</li>
      <li>Use can now only save the prices or only save the configs, instead of always both.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>User Interface Rework</mat-card-title>
    <mat-card-subtitle>July 12th, 2024 (2nd post)</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Reworks:</p>
    <ul class="bullet-point-list">
      <li>The landing page has been completely reworked.</li>
      <li>Multiple UI improvements were also integrated into the website.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Trade Routes finder release in a Beta stage</mat-card-title>
    <mat-card-subtitle>July 12th, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Releases:</p>
    <ul class="bullet-point-list">
      <li>The Trade Routes Finder has been released in a beta stage!</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Improved Flipper, Top Traded Items and Charts</mat-card-title>
    <mat-card-subtitle>July 10th, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Improvements:</p>
    <ul class="bullet-point-list">
      <li>Added UI improvements and the ability to save runes prices to the flipper.</li>
      <li>Top traded items now allows the use of filters for shop categories and sorting by amount or silver.</li>
      <li>Flipper and Meta Items now have charts showing flips and PVP activity.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Improved Meta Items Filter</mat-card-title>
    <mat-card-subtitle>July 3rd, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Improvement:</p>
    <ul class="bullet-point-list">
      <li>Meta Items page now has a filter where you can select the minimum number of times an item was used in PVP the past week.</li>
      <li>This is especially useful if you're sorting by KDR and want to remove unpopular items that have very limited usage.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Upgrade Flips are Live!</mat-card-title>
    <mat-card-subtitle>July 2nd, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Feature:</p>
    <ul class="bullet-point-list">
      <li>Market Flipper now identifies upgrade opportunities.</li>
      <li>It targets items with lower enchantments for purchase, upgrade via runes, and resale.</li>
      <li>This feature provides additional opportunities for players willing to buy runes in bulk, often resulting in higher profits.</li>
      <li>The algorithm efficiently detects upgrade opportunities across all enchantment levels, excpect .4, which are not upgradeable.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Donors tiers!</mat-card-title>
    <mat-card-subtitle>June 23rd, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Feature:</p>
    <ul class="bullet-point-list">
      <li>Added different donors tiers as a way to differentiate and thank our supporters.</li>
      <li>Hopefully, this will allow me to keep the website ad-free.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>New meta items released!</mat-card-title>
    <mat-card-subtitle>June 14, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Feature:</p>
    <ul class="bullet-point-list">
      <li>Added a new meta items page that works for all servers and gives you the ability to filter in multiple ways!</li>
      <li>Ads are gone again! No more ugly stuff on your face.</li>
    </ul>
    <p>Thanks everyone for your continued support!!!</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Multiple Display Options on Price Checker</mat-card-title>
    <mat-card-subtitle>June 2nd, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Feature:</p>
    <ul class="bullet-point-list">
      <li>Added the ability to display a single item, the whole tier (all enchantments) or all tiers and all enchantments of an item in the price checker.</li>
      <li>Show profit/loss % in transport cards.</li>
    </ul>
    <p>Thanks <b>OG Dave</b> and <b>NeverNoFear</b> from our Discord for suggesting it!</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Increased Favorites List</mat-card-title>
    <mat-card-subtitle>June 1st, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Feature:</p>
    <ul class="bullet-point-list">
      <li>Increased favorit list item limit from 15 to 100.</li>
    </ul>
    <p>Thanks <b>OG Dave</b> from our Discord for suggesting it!</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Bug fix</mat-card-title>
    <mat-card-subtitle>May 21, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Bugfix:</p>
    <ul class="bullet-point-list">
      <li>Fixed a bug that was causing wrong focus calculation when refining.</li>
    </ul>
    <p>Thanks <b>Digit</b> from our Discord for reporting it!</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>UI Improvements</mat-card-title>
    <mat-card-subtitle>May 6, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Key Improvements in This Release:</p>
    <ul class="bullet-point-list">
      <li>Added an option to manually enter the resource return rate, since there are multiple combinations for HideOut crafting.</li>
      <li>Added server indicator over the settings button!</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Europe Server</mat-card-title>
    <mat-card-subtitle>April 14, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Key Improvements in This Release:</p>
    <ul class="bullet-point-list">
      <li>All services should be working for the new European Server!</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Top Sold Items</mat-card-title>
    <mat-card-subtitle>March 13, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Key Improvements in This Release:</p>
    <ul class="bullet-point-list">
      <li>We've released the Top Sold Items tool!</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>New languages</mat-card-title>
    <mat-card-subtitle>March 11, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Key Improvements in This Release:</p>
    <ul class="bullet-point-list">
      <li>We've added the new languages supported by Albion Online: Türkçe and العربية.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Enhancing Calculator Performance</mat-card-title>
    <mat-card-subtitle>March 07, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Key Improvements in This Release:</p>
    <ul class="bullet-point-list">
      <li>Due to the increasing popularity of our calculator among refiners, we observed performance issues when processing a high number of runs.</li>
      <li>To address this, we have optimized the algorithm for these scenarios, significantly improving efficiency while maintaining a high level of accuracy.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Market Flipper on East Server</mat-card-title>
    <mat-card-subtitle>March 5th, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Highlights of This Release:</p>
    <ul class="bullet-point-list">
      <li>Now the market flipper tool also works on the East Server!!!</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Market Flipper</mat-card-title>
    <mat-card-subtitle>February 26, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Highlights of This Release:</p>
    <ul class="bullet-point-list">
      <li>
        Albion Free Market has joined the big leagues and is now accessible at
        <a href="https://www.albionfreemarket.com" target="_blank">www.albionfreemarket.com</a>!
      </li>
      <li>We've released the much-anticipated Market Flipper tool.</li>
      <li>Instructions are provided on the page.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Meta Items</mat-card-title>
    <mat-card-subtitle>February 7, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Highlights of This Release:</p>
    <ul class="bullet-point-list">
      <li>We've introduced the Meta Items section, where you can review the most frequently used items during combat.</li>
      <li>The Albion developers have removed market encryption, so we've reverted to displaying selling prices by default!</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Price Refresh Feature</mat-card-title>
    <mat-card-subtitle>January 13, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Highlights of This Release:</p>
    <ul class="bullet-point-list">
      <li>All ads were removed!!!</li>
      <li>By popular demand, we've introduced a 'Refresh Prices' button on all pages.</li>
      <li>This feature enables you to update the prices without the need for page navigation.</li>
      <li>Be aware, on the crafting page and transport page, a warning will appear warning that you're about to lose manually entered prices.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Crafts now consider left over materials</mat-card-title>
    <mat-card-subtitle>January 3rd, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>What's New in This Release:</p>
    <ul class="bullet-point-list">
      <li>The crafting calculator now accounts for leftover ingredients, enhancing the accuracy of your crafting calculations.</li>
      <li>Leftover materials contribute to the total income, assuming they are sold at their original purchase price via a sell order.</li>
      <li>
        Currently, there's no option to sell leftovers to a buy order. We've prioritized simplicity and user experience over adding another settings menu to our already comprehensive tool, especially given the minimal gains this feature
        would provide.
      </li>
      <li>If you prefer not to include leftovers in your calculations, simply set their amount to 0.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Filter Prices by Cities</mat-card-title>
    <mat-card-subtitle>January 1st, 2024</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>What's New in This Release:</p>
    <ul class="bullet-point-list">
      <li>You can now choose which cities' prices you'd like to display.</li>
      <li>This feature can be used by clicking on the city name in the city legends. A single click disables the city, and another click re-enables it.</li>
      <li>This feature is available in the price checker, favorites, and Item Power sections. We strongly recommend checking out the Item Power comparison tool with this new filter, as it's now more useful than ever.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>UI Improvements</mat-card-title>
    <mat-card-subtitle>December 20, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>What's New in This Release:</p>
    <ul class="bullet-point-list">
      <li>After all the bug fixing with the new login systems, we started working on the UI.</li>
      <li>Some improvements in the My Crafts table so it looks a little better. We will still a lot more data to that table, so stay tuned.</li>
      <li>Some other UI improvements all around.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Back End Updates and Bug Fixes</mat-card-title>
    <mat-card-subtitle>December 18, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>What's New in This Release:</p>
    <ul class="bullet-point-list">
      <li>We heard you! As MANY people warned us, there were some bad bugs in the data persistance logic. We are happy to announce it's all fixed!</li>
      <li>Crafting and Transport configurations are now manually saved, so you can test changes.</li>
      <li>Website responsiveness was improved when changing languages or servers.</li>
      <li>Some UI improvements.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>User Created Favorite Items Lists for Prices</mat-card-title>
    <mat-card-subtitle>December 14, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>What's New in This Release:</p>
    <ul class="bullet-point-list">
      <li>You can now create up to 20 lists of favorite items to see their prices all at once.</li>
      <li>Each list can hold up to 15 items.</li>
      <li>If you find any bugs please send us feedback.</li>
      <li>Some UI improvements.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Google Login</mat-card-title>
    <mat-card-subtitle>December 10, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>What's New in This Release:</p>
    <ul class="bullet-point-list">
      <li>You can login using your Google account. So far there's no actual functionality to this, but in the future our team will add lots of exciting stuff.</li>
      <li>You can support us by <a href="https://ko-fi.com/albionfreemarket">buying us a Coffee</a>.</li>
      <li>Couple UI improvements.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Price Card Improvements</mat-card-title>
    <mat-card-subtitle>November 23, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>What's New in This Release:</p>
    <ul class="bullet-point-list">
      <li>When you click on a price in the price card the history chart will appear in the bottom.</li>
      <li>Massive performance improvements for the charts.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>We've Gone International!</mat-card-title>
    <mat-card-subtitle>November 22, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>What's New in This Release:</p>
    <ul class="bullet-point-list">
      <li>You can now select your preferred language in the top right corner.</li>
      <li>The language setting is applied to in-game item names, shop names, and Destiny Board names.</li>
      <li>We may expand these features in the future. For now, it's a significant update, and players who do not use English can copy and paste item names directly into the game!</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>More Crafting Improvements & UI Enhancements</mat-card-title>
    <mat-card-subtitle>November 21, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>What's New in This Release:</p>
    <ul class="bullet-point-list">
      <li><strong>Expanded Crafting Options:</strong> All items within a category are now visible at once in the crafting screen, allowing for informed decisions and maximized profits.</li>
      <li><strong>Weight Information:</strong> Crafting cards now include item weight data for better planning.</li>
      <li><strong>Enhanced Card Features:</strong> Crafting and transport cards feature convenient copy and price check buttons for quick actions.</li>
      <li><strong>Seamless Server Switch:</strong> Automatic page reload on server change, ensuring a smooth transition and clarity.</li>
      <li><strong>No more doubts:</strong> Added FAQ page.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Crafting Improvements</mat-card-title>
    <mat-card-subtitle>November 20, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Here's what's new in this release:</p>
    <ul class="bullet-point-list">
      <li>The focus cost of crafting is now calculated from the user's set specs. You don't need to sum it up yourself anymore!</li>
      <li>Specs are persisted in the browser's local storage.</li>
      <li>Added button to copy item name from craft and transport item card (use it to paste ingame).</li>
      <li>Improved first loading time.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Transport is in! Massive updates!</mat-card-title>
    <mat-card-subtitle>November 15, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Here's what's new in this release:</p>
    <ul class="bullet-point-list">
      <li>We added the transport tool!</li>
      <li>We added feedback contact trough our e-mail and Discord server.</li>
      <li>UI/UX improvements everywhere.</li>
      <li>Changed theme colors and streamlined the changes.</li>
      <li>Lot's of internal code improvements to facilitate future development.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Behold! The Craft of Charts Ascends!</mat-card-title>
    <mat-card-subtitle>November 10, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Hark! Lend thine ear to the latest chronicle of our grand endeavor:</p>
    <ul class="bullet-point-list">
      <li>Lo and behold, for unto every crafting product and ingredient, we have bestow'd charts of price and quantity!</li>
      <li>In sooth, thou canst now discern if thy prices be high, low, or in harmony with the common weal!</li>
      <li>For wares of divergent quality, fear not! For calculations encompass all varieties with meticulous care!</li>
      <li>Verily, in the realm of commerce, the Albion Free Market doth shine as a beacon amongst its peers.</li>
      <li>And remember, this revolutionary tool is but in its infancy; pray, leave us thy candid feedback (found at the menu's end) for any encumbrances encountered.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Crafting Improvements</mat-card-title>
    <mat-card-subtitle>November 9, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Here's what's new in this release:</p>
    <ul class="bullet-point-list">
      <li>Price checker can now show prices averages!</li>
      <li>When you choose averages, the top right badge will show the average amount of sales per day!</li>
      <li>Several UI improvements.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Crafting Improvements</mat-card-title>
    <mat-card-subtitle>November 8, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Here's what's new in this release:</p>
    <ul class="bullet-point-list">
      <li>Now you can select if you want to use journals in a craft.</li>
      <li>Sales taxes are automatic based on Premium selection. Premium determines both Sales Taxes and Fame.</li>
      <li>Fixed a bug in the crafting balance sheet.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Hark! The Dawn of Enhanced Trade Awaits</mat-card-title>
    <mat-card-subtitle>November 7, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>
      O Ye faithful stewards of the Albion Free Market, gather 'round as we proclaim the tidings of progress and prosperity bestowed upon our digital congregation. On this day, as the celestial spheres align, our venerated codex of commerce
      has been graced with divinely inspired enhancements.
    </p>
    <p>Let us raise our voices in jubilation for the miracles wrought by our guardians of the code:</p>
    <ul class="bullet-point-list">
      <li>In the hallowed halls of the price checker, ye may now discern the value of goods with a divine clarity, selecting the type of price with the wisdom of Solomon.</li>
      <li>Behold the craft results UI, now transfigured with improvements that shine like the morning star, guiding your artisanal journey towards perfection.</li>
      <li>The label of Premium Fame has been anointed with a new appellation, reflecting its exalted status amidst the pantheon of trade.</li>
      <li>Rejoice, for the scripture of layout has undergone a sacred refinement, ensuring that your path through the marketplace is as seamless as the flight of an angel.</li>
      <li>And lo, the pricecard layout has been imbued with enhancements, now resplendent as a king's tapestry, inviting all to partake in its beauty.</li>
    </ul>
    <p>
      Go forth, ye merchants of distinction, with hearts uplifted and spirits renewed by the knowledge of these advancements. Let the bells of Albion chime in harmony with our collective endeavor, as we forge a marketplace that echoes
      through the heavens.
    </p>
    <p>We adjourn with a benediction of continued abundance and wisdom upon your mercantile ventures. May your coffers overflow as bountifully as the river of life, and may your trades be ever in your favor.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Chronicles of Progress: The November 5th Scrolls</mat-card-title>
    <mat-card-subtitle>November 5, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>
      Valiant Users of the Albion Free Market, on this day, the fifth of November, our fellowship has toiled under moon and sun, bringing forth advancements to the grand bazaar that would leave even the Knights of the Round Table in awe.
    </p>
    <p>Heed the call of the herald as we unveil the sagas of development:</p>
    <ul class="bullet-point-list">
      <li>By the decree of our digital masons, the <strong>Forms Layout</strong> now dances with responsiveness, bending gracefully to the will of your steeds and carriages, be they grand or modest in size.</li>
      <li>From the depths of the code mines, bugs of dire annoyance have been smote with the hammer of resolution, ensuring a marketplace pure as a unicorn's heart.</li>
      <li>The artisans' canvas, known as the <strong>Dark Mode Theme</strong>, has been woven with threads of night and shadow, offering a visage of elegance to comfort thy eyes in the twilight hours.</li>
      <li>With wisdom and alchemy, the <strong>Item Trade Card Component</strong> has been transmuted to better serve the hands that forge and trade within the bustling squares of our digital Camelot.</li>
      <li>Let it be known that warnings of price absence shall now appear, like ghosts to heed, guiding thee away from the pitfalls of commerce.</li>
    </ul>
    <p>Ride forth into the marketplace with renewed vigor, for the path has been laid clear and true. We remain, as ever, your humble servants in the quest for mercantile supremacy.</p>
    <p>Until we next cross quills, may your coffers be full and your trades be prosperous.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>An Offer You Can't Refuse: Finely-Crafted Updates</mat-card-title>
    <mat-card-subtitle>November 2, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>
      Dear Esteemed Patrons of Albion Free Market, as the cool winds of November grace the landscapes of Albion, so do a series of finely-crafted updates descend upon our humble marketplace. In our unyielding quest for excellence, we
      present to you a spread of enhancements that even the Godfather would nod approvingly at.
    </p>
    <p>Allow us to lead you through the garden of our latest accomplishments:</p>
    <ul class="bullet-point-list">
      <li>With a meticulous eye, we've attended to the <strong>Crafting Rounding</strong> which now performs with a precision that rivals the sharpness of a Corleone's blade.</li>
      <li>
        The <strong>Craft Calculator</strong>, once in beta, now stands tall in its full glory, having been tested through the crucible of Albion's finest craftsmen. No stone was left unturned, no error left lurking in the shadows. However,
        should you stumble upon a whisper of a mistake, we invite you to make your voice heard in the halls of the
        <a href="https://forum.albiononline.com/index.php/Thread/187846-Albion-Free-Market-price-check-crafting-and-IP-comparison/" style="text-decoration: none; color: #3498db" target="_blank">Albion Online Forum</a>.
      </li>
      <li>Our calculations have taken a step closer to the divine with <strong>Different Calculations for Journal and Player Fame</strong>, embracing the myriad ways in which fame graces the worthy.</li>
      <li>And, in a quiet alley, a bug met its fate as we fixed the <strong>Journal Max Fame</strong>, restoring order to the annals of Albion Free Market.</li>
    </ul>
    <p>Your journey through the alleys of Albion Free Market shall now be graced with the gentle touch of perfection, as our unwavering dedication continues to craft a sanctuary of commerce.</p>
    <p>We extend our gratitude for your patronage and invite you to revel in the fruits of our labor. Till our paths cross again in the market square, we bid you good fortune on all your endeavors.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Unveiling a New Epoch of Convenience and Efficiency</mat-card-title>
    <mat-card-subtitle>November 1, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>
      Dear Albion Patrons, the advent of November brings with it a cascade of groundbreaking enhancements to the Albion Free Market. Our relentless pursuit of perfection has borne fruit, and we're thrilled to share the bounty with our
      cherished community.
    </p>
    <p>Here's a glimpse of the transformative updates:</p>
    <ul class="bullet-point-list">
      <li>Introducing a robust <strong>Search Functionality</strong> for the seamless selection of shop categories and items, catering to your specific needs with precision.</li>
      <li>The much-anticipated <strong>Persistence Feature</strong> is now live! Rejoice as the server you selected and your crafting categories will be saved for other sessions. Say goodbye to the tedious resets!</li>
      <li>Experience a wave of <strong>UI Improvements</strong> across the board, designed to offer a more intuitive and visually appealing interaction.</li>
      <li>Embark on <strong>Price Checks, Crafts, or IP Comparisons</strong> swiftly by passing the item unique name as a <strong>URL parameter</strong>.</li>
    </ul>
    <p>
      We'd like to extend a special note of gratitude to
      <span style="font-weight: bold; color: #3498db">Platynowa, the Fabled Noob of the Highlands, leader of the Platinum Empire (PTE)</span>, whose invaluable contributions have played a pivotal role in this release. Your unwavering
      support propels us to strive for higher pinnacles.
    </p>
    <p>As we step into this new era, we remain steadfast in our mission to elevate the Albion Free Market to unparalleled heights. Stay tuned for a journey filled with relentless innovation and superior user-centric solutions.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Groundbreaking Performance Leap!</mat-card-title>
    <mat-card-subtitle>October 31, 2023 - second update!</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>
      Today, we are thrilled to unveil a monumental stride in Albion Free Market's technical prowess. Our indefatigable engineering brigade has achieved the unimaginable—enhancing the performance of reading the Albion Online static data by
      an astounding factor of 10!
    </p>
    <p>
      This seismic advancement underscores our unwavering commitment to elevating your experience. We recognize the weight of milliseconds in the digital age, and with this leap, we've slashed wait times, propelling us to the vanguard of
      technological excellence.
    </p>
    <ul class="bullet-point-list">
      <li>The release of the balance sheet, a beacon of transparency, now illuminates the craft details. While it's in its nascent stage, anticipate it to evolve, refine, and surpass your expectations in the forthcoming iterations.</li>
      <li>Our engineering marvels didn't just stop at performance optimization. With an eye on the future, they've laid the groundwork for many more exhilarating updates, ensuring Albion Free Market stays at the cutting edge.</li>
    </ul>
    <p>Join us in celebrating this watershed moment. Here's to blazing new trails and shaping the future of Albion's digital marketplace!</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Revolutionizing User Experience</mat-card-title>
    <mat-card-subtitle>October 31, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Greetings, Esteemed Albion Moguls! The innovation engine at Albion Free Market has once again roared to life, ushering in a new era of user-centric enhancements.</p>
    <p>Today marks the dawn of an elevated user experience, meticulously refined to meet the discerning tastes of our cherished community. Here’s a glimpse of the transformative updates:</p>
    <ul class="bullet-point-list">
      <li>Introducing a streamlined item selection in the price checker, abolishing the need to trawl through the entire market category—a godsend for our friends on lower-end devices.</li>
      <li>Behold the revitalized Price Checker UI, now resonating with the vibrant hues of in-game cities, melding the virtual and the real in a visual feast.</li>
      <li>Unveiling the city legend, your new compass in navigating the bustling marketplaces of Albion.</li>
      <li>Quality indicators now grace our price cards, bestowing a clear vista of value at a glance.</li>
      <li>The crafting calculator has undergone a metamorphosis, preserving the Craft object, and catapulting responsiveness to new heights.</li>
      <li>And when multiple recipes beckon, fear not! The crafting calculator now proudly displays the recipe number, banishing any trace of ambiguity.</li>
    </ul>
    <p>Our journey towards perfection marches on. In the anvil are detailed breakdowns of costs and revenue within the crafting calculator, to empower you with crystal-clear insights ensuring every trade is a triumph.</p>
    <p>The sails are set, and our dedicated team is laser-focused on forging ahead with these exhilarating features. Stay tuned for the unfolding saga of relentless innovation here at Albion Free Market!</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Firebase Hosting</mat-card-title>
    <mat-card-subtitle>October 30, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>We moved our hosting to Firebase, so we don't need to rely on GitHub Pages anymore.</p>
    <p>Our new site is <a href="https://albionfreemarket.web.app" target="_blank">https://albionfreemarket.web.app</a>.</p>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Server selection, Improved UX</mat-card-title>
    <mat-card-subtitle>October 26, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Here's what's new in this release:</p>
    <ul class="bullet-point-list">
      <li>You can now choose from East or West server. West is default.</li>
      <li>Improved menu interaction for mobile users.</li>
      <li>Progress in the crafting tool, but still not ready.</li>
      <li>Added credit to The Albion Online Data Project.</li>
    </ul>
  </mat-card-content>
</mat-card>

<mat-card class="change-log-card">
  <mat-card-header>
    <mat-card-title>Improved item selection, crafting under work</mat-card-title>
    <mat-card-subtitle>October 25, 2023</mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <p>Here's what's new in this release:</p>
    <ul class="bullet-point-list">
      <li>Added Crafting section, still under work. Most of the behind the scenes is done so it's only a matter of time now.</li>
      <li>Shop categories, subcategories and items selection lists are now pre-filtered based on the wanted data.</li>
      <li>Added change log section.</li>
    </ul>
  </mat-card-content>
</mat-card>
